export default __webpack_public_path__ + "static/placeholder-meal-f060297ea2a75059288a934cdd382bb7.jpg";